export function initCatalogButton(){
    const body = document.body;
    const catalogButton = document.querySelector('.header-catalog-button') as HTMLElement | null;
    const catalogMenu = document.querySelector('.catalog-menu') as HTMLElement | null;

    if (catalogButton && catalogMenu) {

        // Клик по кнопке — открыть/закрыть
        catalogButton.addEventListener('click', (e) => {
            e.stopPropagation();
            body.classList.toggle('show-catalog');
        });

        // Клик внутри меню — не закрываем
        catalogMenu.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        // Клик вне меню — закрываем
        document.addEventListener('click', () => {
            body.classList.remove('show-catalog');
        });

        // ESC — закрыть
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                body.classList.remove('show-catalog');
            }
        });

        // Скролл — закрыть
        window.addEventListener('scroll', () => {
            body.classList.remove('show-catalog');
        });
    }

}